"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

const SvgBell = props => {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M24.931 32.4a1 1 0 011.666 1.102 3 3 0 01-5.19 0 1 1 0 111.73-1.004 1 1 0 001.73 0zm-.93-19.4a7 7 0 017 7c0 2.9.524 5.079 1.379 6.646.286.525.586.935.879 1.244.158.167.265.256.298.278.823.549.434 1.832-.555 1.832h-18c-.99 0-1.378-1.283-.555-1.832.033-.022.14-.11.298-.278.292-.309.593-.719.879-1.244.855-1.567 1.378-3.746 1.378-6.646a7 7 0 017-7zm0 2a5 5 0 00-5 5c0 3.225-.601 5.734-1.621 7.604-.076.138-.152.27-.228.396h13.7a10.21 10.21 0 01-.228-.396c-1.02-1.87-1.622-4.379-1.622-7.604a5 5 0 00-5-5z",
    id: "bell_svg__a"
  }));
};

var _default = SvgBell;
exports.default = _default;